import firebase from 'firebase/app'
import "firebase/analytics";
import 'firebase/auth'
import 'firebase/firestore'
import 'firebase/storage'

const firebaseConfig = {
    apiKey: "AIzaSyD5r-Xx09cHyOfAyeQf272QNYPHLU2gVgk",
    authDomain: "eest-n2.firebaseapp.com",
    projectId: "eest-n2",
    storageBucket: "eest-n2.appspot.com",
    messagingSenderId: "692369106335",
    appId: "1:692369106335:web:2a056d82dd225be98409aa"
}


firebase.initializeApp(firebaseConfig)
firebase.analytics();


export const auth = firebase.auth()
export const db = firebase.firestore()
export const storage = firebase.storage()
